import { useEffect } from "react";
import { useEntityKey } from "../accessorPropagation/useEntityKey.js";
import { useGetEntityByKey } from "../accessorPropagation/useGetEntityByKey.js";
function useEntityEvent(type, ...args) {
  const entityKey = useEntityKey();
  const getEntityByKey = useGetEntityByKey();
  const potentiallyStaleParent = getEntityByKey(entityKey);
  const stableGetEntityReference = potentiallyStaleParent.getAccessor;
  useEffect(() => {
    const entityAccessor = stableGetEntityReference();
    if (type === "connectionUpdate") {
      return entityAccessor.addEventListener(
        {
          type,
          key: args[0]
        },
        args[1]
      );
    } else {
      return entityAccessor.addEventListener(
        {
          type
        },
        args[0]
      );
    }
  }, [...args, stableGetEntityReference]);
}
export {
  useEntityEvent
};
//# sourceMappingURL=useEntityEvent.js.map
